import {Injectable} from "@angular/core";
import {PersistenceService} from "./persistence.service";
import {Child, GroupLinks, StudentDashboard, StudentSelfDashboard, StudentSelfGroup} from "../../types/interfaces";
import {BehaviorSubject, map, Observable, tap} from "rxjs";
import {
    EducationMaterialApi, EnglishLevelApiResponse,
    ParentDashboardApiResponse,
    StartTestApiResponse,
    StudentBonusesApiResponse, StudentCountricsHistoryResponse,
    StudentDashboardApiResponse,
    StudentExamAnswerApiResponse, StudentScheduleApiResponse,
    StudentSelfDashboardApiResponse,
    StudentStudyHistoryApiResponse,
    StudentStudyProgressApiResponse,
    StudentTestsApiResponse
} from "../../types/apiResponse.interface";
import {ApiService} from "./api.service";
import {AuthService} from "./auth.service";
import {PreloaderService} from "../preloader/preloader.service";
import {Router} from "@angular/router";
import {ParentService} from "./parent.service";
import {AlertService} from "../alert/alert.service";


@Injectable({
    providedIn: 'root'
})
export class StudentService {

    // private currentGroups$ = new BehaviorSubject<StudentSelfGroup[] | null>(null);
    private currentGroupsLinks$ = new BehaviorSubject<GroupLinks[] | null>(null);
    activeChild$ = this.parentService.getActiveChild();
    child: Child | undefined = undefined;


    constructor(
        private persistenceService: PersistenceService,
        private apiService: ApiService,
        private authService: AuthService,
        private preloaderService: PreloaderService,
        public router: Router,
        private parentService: ParentService,
        public alertService: AlertService,
    ) {

        let persistedGroups = this.persistenceService.get('activeTabGroupsLinks') as GroupLinks[];

        if (persistedGroups) {
            this.setCurrentGroupsLinks(persistedGroups);
        }

        this.currentGroupsLinks$.subscribe({
            next: (currentGroups: GroupLinks[] | null) => {

                this.persistenceService.set('activeTabGroupsLinks', currentGroups);

                if (!this.currentGroupsLinks$.getValue() && currentGroups && currentGroups.length > 0) {
                    this.currentGroupsLinks$.next(currentGroups);
                }
            }

        })

        this.activeChild$.subscribe({
            next: (child) => {
                if (child) {
                    this.child = child
                }

            }
        })

    }

    //
    // setCurrentGroups(groups: StudentSelfGroup[]): void {
    //
    //     this.currentGroups$.next(groups);
    //
    // }
    //
    // getCurrentGroups(): BehaviorSubject<StudentSelfGroup[] | null> {
    //
    //     return this.currentGroups$;
    //
    // }
    //

    setActiveGroupsIds(groupIds: Array<number>): void {

        this.persistenceService.set(`activeGroupsIds`, groupIds);

    }

    getActiveGroupsIds(): number[] {
        return this.persistenceService.get(`activeGroupsIds`) as number[];
    }

    setActivePaidGroupsIds(groupIds: Array<number>): void {

        this.persistenceService.set(`activePaidGroupsIds`, groupIds);

    }

    getActivePaidGroupsIds(): number[] {
        return this.persistenceService.get(`activePaidGroupsIds`) as number[];
    }

    getExamInfoShowAt():string {
        return this.persistenceService.get(`examsInfoShowedAt`) as string;
    }

    setExamInfoShowAt(data: string): void {

        this.persistenceService.set(`examsInfoShowedAt`, data);

    }



    setCurrentGroupsLinks(groups: GroupLinks[]): void {

        this.currentGroupsLinks$.next(groups);

    }

    getCurrentGroupsLinks(): BehaviorSubject<GroupLinks[] | null> {

        return this.currentGroupsLinks$;

    }

    public getDashboard(activeTab: string | null): Observable<StudentSelfDashboard> {
        return this.apiService
            .sendApiRequest('/student/dashboard', {activeTab: activeTab}, 'post')
            .pipe(
                map((response: any) => {
                    return response;
                }),
                tap(response => {

                    this.setActiveChildPhone(response.phone)
                    this.setActiveChildEmail(response.email)

                    // let currentGroups = response.groups.filter(group => group.time === 'isCurrent');
                    // let pastGroups = response.groups.filter(group => group.time === 'isPast').map(group => group.id);
                    // let futureGroups = response.groups.filter(group => group.time === 'isFuture').map(group => group.id);
                    // let currentPaidGroupsIds = currentGroups.map(group => group.id);
                    //
                    // let currentGroupsHasReserve = currentGroups.filter(group => group.isReserve).length > 0;
                    //
                    // this.persistenceService.set('studentCurrentGroupsIds', currentPaidGroupsIds);
                    // this.persistenceService.set('studentCurrentGroupsAllReserve', currentGroupsHasReserve);
                    //
                    //
                    // this.persistenceService.set('studentPastGroupsIds', pastGroups);
                    // this.persistenceService.set('studentFutureGroupsIds', futureGroups);
                    // this.setCurrentGroups(currentGroups);

                })
            );

    }

    public getEducationalMaterial(groupId: string): Observable<EducationMaterialApi> {
        return this.apiService
            .sendApiRequest('/student/educational-material/' + groupId, 'get')
            .pipe(
                map((response: any) => {
                    return {
                        id: response.id,
                        educationalMaterialId: response.educationalMaterialId,
                        info: response.info,
                        textbook: response.textbook
                    };
                }),
                tap(response => {

                })
            );

    }

    public getCertificates(): Observable<StudentStudyHistoryApiResponse> {
        return this.apiService
            .sendApiRequest('/student/certificates', 'get')
            .pipe(
                map((response: any) => {
                    return {
                        history: response.history,
                    };
                })
            );

    }


    public applyBirthCountrics(phone: string) {
        return this.apiService
            .sendApiRequest('/student/birthday-countrics', {phone: phone}, 'post')
            .pipe(
                map((response: any) => {


                    return {};
                })
            );

    }


    public getExams(): Observable<StudentTestsApiResponse> {
        return this.apiService
            .sendApiRequest('/student/exams', 'get')
            .pipe(
                map((response: any) => {
                    return {
                        studentId: response.studentId,
                        examsData: response.examsData,
                    }
                })
            );

    }

    public showExamAnswers(uuid: string): Observable<StudentExamAnswerApiResponse> {
        return this.apiService
            .sendApiRequest('/student/exam-answers/' + uuid, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        uuid: response.uuid,
                        url: response.url,
                    }
                })
            );

    }

    public getExamUrl(uuid: string): Observable<StudentExamAnswerApiResponse> {
        return this.apiService
            .sendApiRequest('/student/exam-url/' + uuid, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        uuid: response.uuid,
                        url: response.url,
                    }
                })
            );

    }


    public getStudyProgress(groupIds: { id: number, target: boolean }[]): Observable<StudentStudyProgressApiResponse> {
        return this.apiService
            .sendApiRequest('/student/progress', {groupIds: groupIds}, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        education: response.education,
                    };
                })
            );
    }


    public getCountricsHistory(withoutLimit: boolean): Observable<StudentCountricsHistoryResponse> {
        const method = withoutLimit ? '/student/countrics-history/without-limit' : '/student/countrics-history';

        return this.apiService
            .sendApiRequest(method, 'get')
            .pipe(
                map((response: any) => {
                    return {
                        history: response.history,
                        url: response.url,
                        amount: response.amount,
                        moreStory: response.moreStory,
                        videoUrl: response.videoUrl
                    };
                })
            );
    }

    public getSchedule(): Observable<StudentScheduleApiResponse> {
        return this.apiService
            .sendApiRequest('/student/schedule', 'get')
            .pipe(
                map((response: any) => {
                    return {
                        studentId: response.studentId,
                        groups: response.groups
                    };
                })
            );
    }

    cleanStudentStorage() {
        this.persistenceService.remove('studentCurrentGroups');
        this.persistenceService.remove('studentCurrentGroupsIds');
        this.persistenceService.remove('studentCurrentGroupsAllReserve');
        this.persistenceService.remove('studentPastGroupsIds');
        this.persistenceService.remove('studentFutureGroupsIds');
    }

    goToParentDashboard() {
        if (this.authService.getType() as string == 'parent' && this.child?.phone_2) {
            this.preloaderService.showLoading("Зачекайте, будь ласка");
            this.authService.setLoginRole('parent');

            let authType = this.authService.getType() as string;

            this.authService
                .login(this.child?.phone_2, 'parent', authType)
                .subscribe({
                    next: () => {

                        this.cleanStudentStorage();

                        this.router.navigate(['/home']).then(() => {
                            setTimeout(() => {
                                window.location.reload();
                            }, 50);
                        });

                    },
                    error: (errorResponse: any) => {

                        console.log(errorResponse)

                    },
                    complete: () => {

                        this.preloaderService.hideLoading();

                    }
                })


        } else {
            this.alertService.presentAlert(
                'cannot enter as a parent',
                '',
                [{text: 'ok',}]);

        }

    }

    // public getStudentBonuses(id: number): Observable<StudentBonusesApiResponse> {
    //
    //     return this.apiService
    //         .sendApiRequest('/parent/student-bonuses/' + id, 'get')
    //         .pipe(
    //             map((response: any) => {
    //                 return {
    //                     balance: response.balance,
    //                     refUrl: response.refUrl,
    //                     awards: response.awards,
    //                     registeredStudents: response.registeredStudents
    //                 };
    //             })
    //         );
    //
    // }

    // public getStudentStudyHistory(id: number): Observable<StudentStudyHistoryApiResponse> {
    //
    //     return this.apiService
    //         .sendApiRequest('/parent/student-history/' + id, 'get')
    //         .pipe(
    //             map((response: any) => {
    //                 return {
    //                     history: response.history,
    //                 };
    //             })
    //         );
    //
    // }

    // public getStudentStudyProgress(id: number, groupId: {
    //     id: number,
    //     target: boolean
    // }[]): Observable<StudentStudyProgressApiResponse> {
    //
    //     return this.apiService
    //         .sendApiRequest('/parent/student-progress', {id: id, groupId: groupId}, 'post')
    //         .pipe(
    //             map((response: any) => {
    //                 return {
    //                     education: response.education,
    //                 };
    //             })
    //         );
    //
    // }

    public startTest(): Observable<StartTestApiResponse> {

        return this.apiService
            .sendApiRequest('/student/start-test', 'get')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,
                    };
                })
            );

    }


    public getEnglishLevelTestUrl(): Observable<EnglishLevelApiResponse> {

        return this.apiService
            .sendApiRequest('/student/english-level-test-url', 'get')
            .pipe(
                map((response: any) => {
                    return {
                        url: response.data.url,
                    }
                })
            );

    }

    setActiveChildEmail(childEmail: string): void {

        this.persistenceService.set('activeChildEmail', childEmail);

    }

    setActiveChildPhone(childPhone: string): void {

        this.persistenceService.set('activeChildPhone', childPhone);

    }


}
